import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../FontAwesomeIcons";

const ORDINE_STATUS_CONFERMATO = 'ordine.confermato';

export class GiftOrderSharingView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false
        };
    }

    copyToClipboard = async () => {
        const link = this.props.orderInfo?.gift_redeem_deepLink || "";

        try {
            await navigator.clipboard.writeText(link);

            this.setState({copied: true});

            // reset the "copied" state after 1.5s
            setTimeout(() => {
                this.setState({copied: false});
            }, 3500);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    shareLink = async () => {
        const link = this.props.orderInfo?.gift_redeem_deepLink || "";

        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Riscatta il tuo regalo",
                    text: "Clicca sul link per riscattare il regalo:",
                    url: link
                });
            } catch (err) {
                console.error("Share failed:", err);
            }
        } else {
            // fallback → copy link
            this.copyToClipboard();
        }
    };

    render() {
        const link = this.props.orderInfo?.gift_redeem_deepLink || "";

        if (this.props.orderInfo.status === ORDINE_STATUS_CONFERMATO) {
            return (
                <div>
                    Paga questo ordine <b>in attività</b> ed una volta completato il pagamento, genereremo un link
                    da girare al ricevente del regalo!
                </div>
            )
        }

        if(parseInt(this.props.orderInfo.gift_redeemed)){
            return (
                <div className={"text-success w-100 text-center"}>
                    <FaSolidIcon name={"gift"}/> Il regalo è stato riscattato con successo!
                </div>
            )
        }

        return (
            <div>
                <div className="mb-3">
                    Per permettere al ricevente di <b>riscattare il regalo</b> condividi questo link, lui dovrà
                    semplicemente <b>cliccare sul link e seguire le istruzioni</b>.
                </div>

                <div className="mb-1">
                    Riceverai un avviso quando il regalo sarà stato riscattato.
                </div>

                {/* Clickable link box */}
                {
                    this.state.copied ?
                        <div className={"text-success w-100 text-center"}>
                            <FaSolidIcon name={"check"}/> Copiato!
                        </div> : <div>&nbsp;</div>
                }
                <div
                    className="p-2"
                    style={{backgroundColor: "#f3f3f3", cursor: "pointer"}}
                    onClick={this.copyToClipboard}
                >
                    <div className="w-75 text-truncate">
                        {link || "Nessun non ancora disponibile"}
                    </div>
                </div>

                {
                    link ?
                        <div className={"mb-4 text-center"}>
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                {/* Share button */}
                                <button className="btn btn-primary btn-block m-2" onClick={this.shareLink}>
                                    Condividi <FaSolidIcon name="share"/>
                                </button>

                                {/* Copy button */}
                                <button className="btn btn-secondary btn-block m-2" onClick={this.copyToClipboard}>
                                    Copia <FaSolidIcon name="copy"/>
                                </button>
                            </div>
                            <small>
                                Il link sarà sempre disponibile nella sezione dedicata agli ordini effettuati
                            </small>
                        </div>
                        :
                        <div className={"text-warning"}>
                            Il link sarà presto nella sezione degli ordini effettuati e potrai condividerlo
                        </div>
                }
            </div>
        );
    }
}

GiftOrderSharingView.propTypes = {
    orderInfo: PropTypes.object
};